(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sur3a-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-sx-menu]');
  if (!b) return;
  var d = document.getElementById(b.getAttribute('aria-controls'));
  if (!d) return;
  var open = d.classList.toggle('is-open');
  b.setAttribute('aria-expanded', open);
  b.setAttribute('aria-label', open ? b.dataset.close : b.dataset.open);
});
document.addEventListener('cart:update', function (e) {
  var n = e.detail && e.detail.data && e.detail.data.itemCount;
  if (typeof n !== 'number') return;
  document.querySelectorAll('[data-sx-cart-count]').forEach(function (el) { el.textContent = n; });
});

  } catch(e) { console.error(e); }
})();
})();
